import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { translate } from '../../helper';

const StyledModal = styled(Modal)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px'
}));

const ModalContent = styled(Box)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '24px',
  maxWidth: '400px',
  width: '90%',
  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
  outline: 'none',
  textAlign: 'center'
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '12px',
  marginTop: '24px',
  justifyContent: 'center'
}));

const ConfirmButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#ef4444',
  color: '#ffffff',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: '600',
  textTransform: 'none',
  minWidth: '80px',
  '&:hover': {
    backgroundColor: '#dc2626'
  }
}));

const CancelButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#f3f4f6',
  color: '#374151',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: '600',
  textTransform: 'none',
  minWidth: '80px',
  '&:hover': {
    backgroundColor: '#e5e7eb'
  }
}));

const ExitConfirmationModal = ({ open, onClose, onConfirm }) => {
  return (
    <StyledModal
      open={open}
      onClose={onClose}
      aria-labelledby="exit-confirmation-title"
      aria-describedby="exit-confirmation-description"
    >
      <ModalContent>
        <Typography
          id="exit-confirmation-title"
          variant="h6"
          component="h4"
          sx={{
            color: '#111827',
            marginBottom: '16px'
          }}
        >
          All unsaved information will be lost. Are you sure you want to exit?
        </Typography>
        
        <ButtonContainer>
          <CancelButton onClick={onClose}>
            {translate('cancel')}
          </CancelButton>
          <ConfirmButton onClick={onConfirm}>
            {translate('capYes')}
          </ConfirmButton>
        </ButtonContainer>
      </ModalContent>
    </StyledModal>
  );
};

export default ExitConfirmationModal;
